import supportedBrowsers from 'hb-react/shared/helpers/supportedBrowsers';

export function isBrowserSupported() {
  // On empty user agent return true
  if (!navigator.userAgent) {
    return true;
  }

  return supportedBrowsers.test(navigator.userAgent);
}

export function __(str) {
  return window && window.__ ? window.__(str) : str;
}
